export const FALLBACK_LOCALE = "en-US"
export const LOKALISE_URL = "https://lokalise.attensi.com/fiesta-components"
